import APIClient from '@/shared/http/clients/api'

const resourceName = 'relatorio/crm'
const APICore = process.env.APIBaseURLCore

const GetAll = (filters, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, filters, config)
const GetAllCardsReport = (dataFilters, limit, index, config = {}) => APIClient.post(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, dataFilters, config)
const ExportAllCardsReport = (dataFilters, config = {}) => APIClient.post(`${APICore}/${resourceName}/export`, dataFilters, config)

const ReportCrmRepository = {
  GetAll,
  GetAllCardsReport,
  ExportAllCardsReport
}

export default ReportCrmRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/reportcrm.js